<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-4 mt-2">
      <h2 class="fw-bold text-dark mb-0">Templates <span class="text-muted fs-5">({{ templates.length }})</span></h2>
    </div>
    <div class="d-flex align-items-center mb-3">
      <b-input-group class="filter">
        <b-form-select v-model="selectedCruiseLine" :options="cruiseLineOptions">
          <option disabled value="null">Cruise Line</option>
        </b-form-select>
        <b-button v-if="selectedCruiseLine" @click="clearCruiseLineFilter" variant="dark" size="sm">
          <span class="mr-2">x</span>
        </b-button>
      </b-input-group>

      <b-input-group class="filter">
        <b-form-select v-model="selectedTourName" :options="tourNameOptions">
          <option disabled value="null">Tour Name</option>
        </b-form-select>
        <b-button v-if="selectedTourName" @click="clearTourNameFilter" variant="dark" size="sm">
          <span class="mr-2">x</span>
        </b-button>
      </b-input-group>

      <b-input-group class="filter">
        <b-form-select v-model="selectedCity" :options="cityOptions">
          <option disabled value="null">Visiting City</option>
        </b-form-select>
        <b-button v-if="selectedCity" @click="clearCityFilter" variant="dark" size="sm">
          <span class="mr-2">x</span>
        </b-button>
      </b-input-group>

      <b-input-group class="filter">
        <b-form-select v-model="selectedEndCity" :options="endCityOptions">
          <option disabled value="null">End City</option>
        </b-form-select>
        <b-button v-if="selectedEndCity" @click="clearEndCityFilter" variant="dark" size="sm">
          <span class="mr-2">x</span>
        </b-button>
      </b-input-group>

      <b-input-group class="filter">
        <b-form-select v-model="selectedType" :options="typeOptions">
          <option disabled value="null">Type</option>
        </b-form-select>
        <b-button v-if="selectedType" @click="clearTypeFilter" variant="dark" size="sm">
          <span class="mr-2">x</span>
        </b-button>
      </b-input-group>
      <button class="btn btn-primary-gradient px-4 py-2 rounded-pill shadow-sm fw-bold ms-auto" @click="navigateToAddPage">
        <i class="fa fa-plus me-2"></i> Add Template
      </button>

    </div>

    <b-table-simple striped hover :items="filteredTemplates" class="table">
      <b-thead>
        <b-tr>
          <b-th>Tour Name</b-th>
          <b-th>Cruise Line</b-th>
          <b-th>Visiting City</b-th>
          <b-th>End City</b-th>
          <b-th>Type</b-th>
          <b-th>US Embassy Contact</b-th>
          <b-th>UK Embassy Contact</b-th>
          <b-th>Actions</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="{ attributes, id } in filteredTemplates" :key="id">
          <b-td>{{ attributes.tour_name }}</b-td>
          <b-td>{{ attributes.cruise_line.data ? attributes.cruise_line.data.attributes.name : 'N/A' }}</b-td>
          <b-td>{{ attributes.city }}</b-td>
          <b-td>{{ attributes.end_city }}</b-td>
          <b-td>{{ attributes.type }}</b-td>
          <b-td>{{ attributes.emergency_contactUS }}</b-td>
          <b-td>{{ attributes.emergency_contactUK }}</b-td>
          <b-td>
            <button class="btn btn-light btn-sm rounded-pill text-primary px-3 fw-bold me-2" @click="navigateToEditPage(id)">
              <i class="fa fa-pen me-1"></i> Edit
            </button>
            <button class="btn btn-light btn-sm rounded-pill text-danger px-3 fw-bold" @click="deleteTemplate(id)">
              <i class="fa fa-trash me-1"></i> Delete
            </button>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>

    <!-- Delete Confirmation Modal -->
    <b-modal id="delete-confirm-modal" title="Confirm Deletion" hide-footer centered header-class="border-0 pb-0" body-class="p-4 text-center" content-class="border-0 shadow-lg rounded-4">
      <div class="mb-4">
        <i class="fa fa-exclamation-triangle text-danger mb-3" style="font-size: 3rem;"></i>
        <h4 class="fw-bold text-dark mb-2">Delete Template?</h4>
        <p class="text-muted">This action cannot be undone. Are you sure you want to permanently delete this template?</p>
      </div>
      <div class="d-flex justify-content-center gap-3 mt-4">
        <button type="button" class="btn btn-light rounded-pill px-4 fw-bold" @click="$bvModal.hide('delete-confirm-modal')">Cancel</button>
        <button type="button" class="btn btn-danger rounded-pill px-4 fw-bold shadow-sm" @click="confirmDelete" :disabled="loading">
          <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
          Yes, Delete
        </button>
      </div>
    </b-modal>
  </div>
</template>


<script>
export default {
  data() {
    return {
      templates: [],
      selectedCruiseLine: null,
      selectedTourName: null,
      selectedCity: null,
      selectedEndCity: null,
      selectedType: null,
      cruiseLineOptions: [],
      tourNameOptions: [],
      cityOptions: [],
      endCityOptions: [],
      typeOptions: [],
      templateToDelete: null,
      loading: false
    };
  },
  async mounted() {
    await this.getData();
  },
  computed: {
    filteredTemplates() {
      let filtered = this.templates;

      if (this.selectedCruiseLine) {
        filtered = filtered.filter(template =>
          template.attributes.cruise_line.data && template.attributes.cruise_line.data.attributes.name === this.selectedCruiseLine
        );
      }

      if (this.selectedTourName) {
        filtered = filtered.filter(template =>
          template.attributes.tour_name === this.selectedTourName
        );
      }

      if (this.selectedCity) {
        filtered = filtered.filter(template =>
          template.attributes.city === this.selectedCity
        );
      }

      if (this.selectedEndCity) {
        filtered = filtered.filter(template =>
          template.attributes.end_city === this.selectedEndCity
        );
      }

      if (this.selectedType) {
        filtered = filtered.filter(template =>
          template.attributes.type === this.selectedType
        );
      }

      return filtered;
    },
  },
  methods: {
    clearCruiseLineFilter() {
      this.selectedCruiseLine = null;
    },
    clearTourNameFilter() {
      this.selectedTourName = null;
    },
    clearCityFilter() {
      this.selectedCity = null;
    },
    clearEndCityFilter() {
      this.selectedEndCity = null;
    },
    clearTypeFilter() {
      this.selectedType = null;
    },
    async getData() {
      const result = await this.$xhr.get("/api/sk-templates?populate=*");
      this.templates = result.data.data;
      this.cruiseLineOptions = [...new Set(this.templates.map(template => template.attributes.cruise_line.data ? template.attributes.cruise_line.data.attributes.name : 'N/A'))];
      this.tourNameOptions = [...new Set(this.templates.map(template => template.attributes.tour_name))];
      this.cityOptions = [...new Set(this.templates.map(template => template.attributes.city))];
      this.endCityOptions = [...new Set(this.templates.map(template => template.attributes.end_city))];
      this.typeOptions = [...new Set(this.templates.map(template => template.attributes.type))];
    },
    async deleteTemplate(id) {
      try {
        const result = await this.$xhr.get(`/api/sk-items?filters[sk_templates][id]=${id}`);
        const associatedItems = result.data.data;
  
        if (associatedItems.length > 0) {
          this.$bvToast.toast('This template is in use. Please delete the item first from Ship call.', { title: 'Cannot Delete', variant: 'danger', solid: true });
          return;
        }
        
        this.templateToDelete = id;
        this.$bvModal.show('delete-confirm-modal');
      } catch (error) {
        console.error('Error checking associations:', error);
      }
    },
    async confirmDelete() {
      if (!this.templateToDelete) return;
      this.loading = true;
      try {
        const deleteResult = await this.$xhr.delete(`/api/sk-templates/${this.templateToDelete}`);
        if (deleteResult.status === 200) {
          await this.getData();
          this.$bvToast.toast('Template deleted successfully!', { title: 'Deleted', variant: 'warning', solid: true });
        }
        this.$bvModal.hide('delete-confirm-modal');
      } catch (error) {
        console.error('Error deleting template:', error);
        this.$bvToast.toast('Failed to delete template.', { title: 'Error', variant: 'danger', solid: true });
      } finally {
        this.loading = false;
        this.templateToDelete = null;
      }
    },
    navigateToAddPage() {
      this.$router.push({ name: 'Template-Add' });
    },
    navigateToEditPage(id) {
      this.$router.push({ name: 'Edit-Template', params: { id } });
    },
  },
};


</script>
<style>
.table {
  font-size: 12px;
}

.filter {
  max-width: 300px;
  margin-right: 10px;
  margin-top: 10px;
}
</style>
